module.exports = "<div [class]=\"getClass()\">\r\n  <div class=\"header-title\">\r\n    <h3><ng-content></ng-content></h3>\r\n  </div>\r\n</div>\r\n\r\n"